import styled from 'styled-components';
import { CheckboxItem } from '@terveystalo/design-system-react-components';

export const CustomCheckbox = styled(CheckboxItem)``;
